import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MdbTableModule } from 'mdb-angular-ui-kit/table';
import { AnimationFrameScheduler } from 'rxjs/internal/scheduler/AnimationFrameScheduler';
import { DbangService } from 'src/app/services/dbang.service';

@Component({
  selector: 'app-daily-update',
  standalone: true,
  templateUrl: './daily-update.component.html',
  styleUrls: ['./daily-update.component.scss'],
  imports: [CommonModule, MdbTableModule]
})
export class DailyUpdateComponent implements OnInit {

  tableData: any = []
  headers = ['Mercato', 'Ultima data DB', 'Ultima data DBang', 'Ultima data Rawal', 'Ultima data Rawal_BT']
  listadati = []
  loading1 = false
  loading2 = false
  loading3 = false
  loading4 = false

  constructor(private service: DbangService) { }

  ngOnInit(): void {
    this.caricaDati()
  }

  caricaDati() {
    this.service.marketsDailyBang().subscribe((data: any) => {
      console.log(data)
      data['data'].map((item: any) => {
        item.newBF = false
        item.newBang2 = false
        item.newRawal = false
        item.newRawalBT = false
        return item
      })
      this.listadati = data['data']
      this.tableData = data['data']
    })
  }

  aggiornaDb() {
    this.loading1 = true
    let totDati = this.listadati.length
    let datiCompletati = 0
    this.listadati.forEach((item: any) => {
      this.service.updateDB(item.market, item.lastbf).subscribe((data: any) => {
        item.newBF = true
        datiCompletati++
        if (datiCompletati == totDati) {
          this.loading1 = false
        }
        if (data['res'] == 'ok') {
          let mm = data['lastbf']
          if (mm) {
            let row: any = this.listadati.find((el: any) => el.market == item.market)
            if (row) {
              row.lastbf = mm
            }
          }
        }
      })
    })
  }

  aggiornaDbang() {
    this.loading2 = true
    let totDati = this.listadati.length
    let datiCompletati = 0
    this.listadati.forEach((item: any) => {
      this.service.updateDailyBang2(item.market).subscribe((data: any) => {
        datiCompletati++
        if (datiCompletati == totDati) {
          this.loading2 = false
        }
        if (data['res'] == 'ok') {
          let mm = data['data']['lastora']
          if (mm) {
            item.lastora = mm
          }
          item.newBang2 = true
        }
      })
    })
  }

  aggiornaDbangRawal() {    
    this.loading3 = true
    let totDati = this.listadati.length
    let datiCompletati = 0
    this.listadati.forEach((item: any) => {
      this.service.updateDailyBang2Rawal(item.market).subscribe((data: any) => {
        datiCompletati++
        if (datiCompletati == totDati) {
          this.loading3 = false
        }
        if (data['res'] == 'ok') {
          let mm = data['data']['giorno']
          if (mm) {
            item.lastrawal = mm
          }
          item.newRawal = true
        }
      })
    })
  }


  aggiornaDbangRawalBT() {
    this.loading4 = true
    let totDati = this.listadati.length
    let datiCompletati = 0
    this.listadati.forEach((item: any) => {
      this.service.updateDailyBang2RawalBT(item.market).subscribe((data: any) => {
        datiCompletati++
        if (datiCompletati == totDati) {
          this.loading4 = false
        }
        if (data['res'] == 'ok') {
          let mm = data['data']['ultimora']
          if (mm) {
            item.lastrawal = mm
          }
          item.newRawalBT = true
        }
      })
    })
  }

}
